/*
----- Google Tag Manager ----- 

Manages Google Tag Manager interactions and custom event tracking

*/

// Default wait timeout.
const defaultWaitTimeout = 5000;

// Supported events, this also acts like a lookup due to Google having their own naming convention.
const eventTypes = {
  "form-submission": 'form_submission',
  "view-item": "view_item",
  "add-to-basket": "add_to_cart",
  "view-basket": "view_cart",
  "begin-checkout": "begin_checkout",
  "add-delivery-information": "add_shipping_info",
  "add-payment-information": "add_payment_info",
  "purchase": "purchase",
  "custom":'custom_event'
};

// Check events are ecommerce eventt, as GA4 Expects this data in a specific structure.
function isEcommerceEvent(event) {
    if (!event) {
        console.error("GTM: No event provided to check whether it is an Ecommerce event");
        return false;
    }
    switch(event) {
        case 'view-item':
        case 'add-to-basket':
        case 'view-basket':
        case 'begin-checkout':
        case 'add-delivery-information':
        case 'add-payment-information':
        case 'purchase':
            return true;
        default:
            return false;
    }
}

// Check if Google Tag Manager is initialised.
function isGtmInitialised() {
    if (typeof window.dataLayer === 'undefined' || !Array.isArray(window.dataLayer)) {
        AXISDebug.output(2,"GTM: dataLayer is not initialized");
        return false;
    }
    // Check if GTM container has loaded (gtm.js event is pushed on load)
    const gtmLoaded = window.dataLayer.some(item => 
        item.event === 'gtm.js' || item['gtm.start']
    );
    if (!gtmLoaded) {
        AXISDebug.output(2,"GTM: Container not yet loaded");
        return false;
    }
    return true;
}

// Wait for GTM to initialise.
function waitForGTM(timeout = defaultWaitTimeout) {
    return new Promise((resolve) => {
        if (isGtmInitialised()) {
            resolve(true);
            return;
        }
        const startTime = Date.now();
        const checkInterval = setInterval(() => {
            if (isGtmInitialised()) {
                clearInterval(checkInterval);
                resolve(true);
            } else if (Date.now() - startTime >= timeout) {
                clearInterval(checkInterval);
                resolve(false);
            }
        });
    })
}

// Build event-specific data structure based on event type
function buildEventData(eventType, data) {
    // Check whether this is an ecommerce event as the data has to be structured differently.
    const isEcommerce = isEcommerceEvent(eventType);
    let eventData = {};
    if (isEcommerce) {
        eventData['ecommerce'] = data;
    } else {
        switch(eventType) {
            case eventTypes['form-submission']:
                if (data.hasOwnProperty('form_id').length) {
                    eventData['form_id'] = data['form_id'];
                }
                if (data.hasOwnProperty('form_name').length) {
                    eventData['form_name'] = data['form_name'];
                }
                if (data.hasOwnProperty('form_classes').length) {
                    eventData['form_classes'] = data['form_classes'];
                }
                break;
            case eventTypes['custom']:
            default:
                // For custom events, pass through all data
                eventData = { ...data };
            break; 
        }
    }
    return eventData;
}

// Push event to data layer
function triggerEvent(eventType, data = {}) {
    if (!isGtmInitialised()) {
        return false;
    }
    try {
        // Build event-specific data structure
        const formattedData = buildEventData(eventType, data);
        // Lookup event type as Google has their own naming conventions.
        const event = eventTypes[eventType];
        // Final structuring data being added to datalayer.
        const eventData = {
            event: event,
            ...formattedData,
            event_id: generateEventId(event),
            timestamp: new Date().toISOString(),
            page_url: window.location.href,
            page_path: window.location.pathname
        }
        // Send to GTM.
        window.dataLayer.push(eventData);
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "GTM: Event " + eventType + " triggered", eventData);
        }
        console.log("GTM: Event " + eventType + " triggered", eventData);
        return true;
    } catch (error) {
        AXISDebug.output(3, "GTM: Error triggering event " + eventType, error);
        return false;
    }
}

// Send any data that is sent by the server on page load.
function onloadEvents() {
    if (!isGtmInitialised()) {
        return false;
    }
    // Get instances.
    const elements = $("[" + expressSelectors()['analytics']['send-event'] + "]");
    if (!elements.length) {
        console.log("GTM: No onload element(s) found");
        return false;
    }
    elements.each(function() {
        const element = $(this);
        jQueryTriggerEvent(element);
    });
}

// Trigger an event via jQuery script block.
function jQueryTriggerEvent(element) {
    if (!element.length) {
        console.error("GTM: jQuery trigger event, no element proivided");
        return false;
    }
     // Get what should be JSON to be parsed.
    const config = element[0].innerHTML
    // Parse json.
    try {
        // Event that will be pushed to GTM.
        const event = JSON.parse(config);
        // Check for event type.
        if (!event.hasOwnProperty('event')) {
            console.error("GTM: No Event type provided", element);
            return false;
        }
        // Check for Data.
        if (!event.hasOwnProperty("data")) {
            console.error("GTM: No Event data provided", element);
            return false;
        }
        console.log("GTM: Event config found", event);
        // Pass event to event handler.
        const handler = triggerEvent(event['event'], event['data']);
    } catch(error) {
        console.error("GTM: Invalid Config", element);
        console.error(error);
    }
}

// Generate unique event_id this will add belt and braces against duplicated events.
function generateEventId(eventName) {
    return `${eventName}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}


var component = {
    supportedEvents: () => {
        return eventTypes;
    },
    onloadEvents: () => {
        return onloadEvents();
    },
    isGtmInitialised: () => {
        return isGtmInitialised();
    },
    jQueryTriggerEvent: (element) => {
        return jQueryTriggerEvent(element);
    },
    triggerEvent: (eventType, data) => {
        return triggerEvent(eventType, data);
    },
    waitForGTM: (timeout) => {
        return waitForGTM(timeout);
    }
}

export { component };
